export default __webpack_public_path__ + "static/limecrime-95dfbb769638245bdb8d4203eb883184.svg";